// extracted by mini-css-extract-plugin
export default {"root":"sizes_root__tF5nW"};